<template>
    <div class="content">
        <Row type="flex" align="middle" class="code-row-bg mb16">
            <Col span="20">
                <Breadcrumb>
                    <Breadcrumb-item to="/">首页</Breadcrumb-item>
                    <Breadcrumb-item to="/my/customizedCCIC/policy">我的保单</Breadcrumb-item>
                    <Breadcrumb-item>保单详情</Breadcrumb-item>
                </Breadcrumb>
            </Col>
            <Col span="4" v-if="info.insurancePolicyStatus=='UNDERWRITING'" class="right">
                <Button type="primary" @click="toRest">保全</Button>
            </Col>
        </Row>
        <!-- 保单信息 -->
        <PolicyBasicInfo class="mb16" :info="info" type="policy"/>
        <!-- 投保公司 -->
        <insuranceCompany class="mb16" :info="info" type="policy" />
        <!-- 被保人信息 -->
        <InsuredPersonInfo class="mb16" :info="info" v-if="info.productCode!='SUNLIGHT_EMPLOYER_LIABILITY'" type="policy" />
        <!-- 保障计划及人员 -->
        <supportPlans :info="info" type="policy" />
    </div>
    </template>
    <script>
        import PolicyBasicInfo from '../common/PolicyBasicInfo'
        import insuranceCompany from '../common/insuranceCompany'
        import supportPlans from '../common/supportPlans'
        import InsuredPersonInfo from '../common/InsuredPersonInfo'
        export default {
            components:{ 
                PolicyBasicInfo,
                insuranceCompany,
                supportPlans,
                InsuredPersonInfo
            },
            data () {
                return {
                    info:{},
                    id:this.$route.params.id,
                    loading:false,
                }
            },
            mounted () {
                this.getInfo();
            },
            methods:{
                /*企业雇主责任险获取订单信息*/
                getInfo () {
                    this.$axios.get('/broker/insurance/policy/detailByPolicyNo',{
                        policyNo: this.id
                    }).then(res=>{
                        this.info=res
                    });
                },
                toRest () {
                    this.$axios.post('/broker/insurance/endorse/preCheck.all',{
                        insurancePolicyId: this.info.insurancePolicyId
                    }).then(res=>{
                        if(res.code==10000000){
                            this.$router.push(`/companyGroupEmployerDadi/edit/${this.info.insurancePolicyId}`)
                        } else {
                            this.$Modal.confirm({
                                title: res.msg,
                                onOk: () => {
                                    this.$router.push(`/companyGroupEmployerDadi/edit/${this.info.insurancePolicyId}`)
                                },
                                onCancel: () => {
                                }
                            });
                        }
                    })
                },
            }
        }
    </script>
    <style lang="less" scoped>
        .content{
            width: 100%;
            height: 100%;
            padding: 15px;
            box-sizing: border-box;
        }
    </style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/policy/detail.vue